/*
    Create by ljs  2016-01-06
*/
"use strict";
angular.module("productManageMentOrderRankModule", [])
    .controller("productManageMentOrderRankCtrl", ["$scope", "trsHttpService", "$stateParams", "rankItems", "trsspliceString", "$modalInstance", "$validation", "modalDialog","productMangageMentNewspaperService",
        function($scope, trsHttpService, $stateParams, rankItems, trsspliceString, $modalInstance, $validation, modalDialog,productMangageMentNewspaperService) {
            initStatus();
            initData();

            function initStatus() {

                $scope.sitePosition = [{
                        value: 1,
                        name: "最前"
                    },
                    {
                        value: 2,
                        name: "最后"
                    },
                    {
                        value: 3,
                        name: "指定位置"
                    }

                ];
                $scope.status.value = 1;


            };

            function initData() {
                var selection = rankItems.selectedArray[0];
                var array = rankItems.array;
                for (var s = 0; s < array.length; s++) {
                    if (selection.CHANNELID == array[s].CHANNELID) {
                        var curP = s;
                        break;
                    }
                };
                $scope.list = {
                    oldPosition: curP + 1,
                    curItemName: rankItems.selectedArray[0].CHNLDESC,
                    SITEORDER: null,
                    allCounts: array.length,
                    objId: selection.CHANNELID,
                    objType: 101                    
                };
            };
            $scope.confirm = function() {
                switch ($scope.status.value) {
                    case 1:
                        $scope.list.SITEORDER = 0;
                        save();
                        break;
                    case 2:
                        $scope.list.SITEORDER = $scope.list.allCounts - 1;
                        save();
                        break;
                    case 3:
                        if (isNaN($scope.list.SITEORDER - 1) || $scope.list.SITEORDER < 1 || $scope.list.SITEORDER > $scope.list.allCounts || Math.floor($scope.list.SITEORDER) != $scope.list.SITEORDER) {
                            modalDialog.alertType("排序失败", "请输入1到" + $scope.list.totalLength + "之间的正整数", "error", false);
                            return;
                        }                        
                        save();
                        break;
                };
            };

            function save() {
                productMangageMentNewspaperService.commOrder($scope.list, function() {
                    
                });
            };
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);